import {
  CheckCircleFilled,
  CloseCircleFilled,
  CopyTwoTone,
} from "@ant-design/icons";
import { Divider, Table } from "antd";
import copy from "copy-to-clipboard";

const PTable = ({ pList, messageApi }) => {
  var cols = [
    {
      title: "Sno.",
      dataIndex: "sno",
      key: "sno",
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
    },
    {
      title: "Generation status",
      dataIndex: "gErr",
      key: "gErr",
      render: (e) =>
        e ? (
          <CloseCircleFilled style={{ color: "#ee2f53", fontSize: "20px" }} />
        ) : (
          <CheckCircleFilled style={{ color: "#49aa19", fontSize: "20px" }} />
        ),
    },
    {
      title: "Ebay HTML code",
      dataIndex: "ebayCode",
      key: "ebayCode",
      render: (e, row) =>
        row.gErr ? (
          "-"
        ) : (
          <CopyTwoTone
            twoToneColor="#459fdd"
            onClick={() => copyHTML(row.sku, e)}
            style={{ fontSize: "20px" }}
          />
        ),
    },
  ];

  const copyHTML = (sku, text) => {
    copy(text);
    messageApi.open({
      type: "success",
      content: `HTML code copied for ${sku}`,
    });
  };

  return (
    <>
      <div style={{ maxWidth: "650px" }}>
        <h3 style={{ margin: "0" }}>Generated codes:</h3>
        <Divider></Divider>
        <Table
          bordered={true}
          sticky={true}
          scroll={{ y: 500 }}
          columns={cols}
          dataSource={pList}
        ></Table>
      </div>
    </>
  );
};

export default PTable;
